import { render, staticRenderFns } from "./QualityControl.vue?vue&type=template&id=245b4787&scoped=true&"
import script from "./QualityControl.vue?vue&type=script&lang=js&"
export * from "./QualityControl.vue?vue&type=script&lang=js&"
import style0 from "./QualityControl.vue?vue&type=style&index=0&id=245b4787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b4787",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol})
